import { IndustryTemplate } from '@/components';
import { lawnCareContent } from '@/data/industries/lawn-care';

export function LawnCarePage() {
  return <IndustryTemplate content={lawnCareContent} />;
}
